module.exports = __webpack_public_path__ + "static/img/6.9a8899b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/6.png
// module id = xsI+
// module chunks = 45